export const IT_ADMIN_CENTER_MENU_ITEM_TYPE = {
  ABOUT_PAGE_EDITOR: 'about-page-editor'
};

export type ItAdminCenterMenuItemType =
  (typeof IT_ADMIN_CENTER_MENU_ITEM_TYPE)[keyof typeof IT_ADMIN_CENTER_MENU_ITEM_TYPE];
